import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { type IAttribute, IModel, TabularTypeDataset } from 'shell-models-lib';
import { format } from 'app/shared/utils/string.util';
import { AmazonRdsSqlServerLinkedService } from 'app/model/linkedservice/amazon-rds-sql-server.linkedservice';

/**
 * AmazonRdsSqlServerTableDataset should inherit SqlServerTableDataset, but dataflow do not support it,
 * so it would cause several problem.
 *
 * TODO: When dataflow support AmazonRdsSqlServerTableDataset, let it inherit SqlServerTableDataset
 */
@Metamodel.model({
    name: adfModelTypeMap.amazonRdsSqlServer.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AmazonRdsSqlServer_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AmazonRdsSqlServer_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AmazonRdsSqlServerLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AmazonRdsSqlServerTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static DATABASE: IAttribute;
    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE'
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
